import Card from "../../Common/components/Card";
import { Mui, MuiIcons } from "@osu/react-ui";
import { useSelector } from "react-redux";
import { selectDatesAndDeadlines } from "../../services/submissionPeriod/slices";
import DeadlinesComponent from "../../Common/components/Deadlines";

function Deadlines({ loading }) {
  const deadlines = useSelector(selectDatesAndDeadlines);
  const hasDeadlines = !!deadlines?.length;
  const title = "Dates and Deadlines";

  if (loading) {
    return (
      <Card Icon={MuiIcons.AccessTime} title={title}>
        <Mui.Skeleton width="100%" />
        <Mui.Skeleton width="30%" />
      </Card>
    );
  }

  return (
    <Card title={title} Icon={MuiIcons.DateRange}>
      {!hasDeadlines && "Dates and deadlines have not been finalized."}
      <DeadlinesComponent />
    </Card>
  );
}

export default Deadlines;
